import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";

/* ------------------ DEROGATORY CLEANUP UI ------------------ */

const DerogatoryCleanup = ({ data }) => {
    if (!data) return null;

    const {
        recommendationNo,
        // heading,
        priority,
        impactRange,
        timeline,
        heading = "Clean Up Settled Accounts",
        // priority = "HIGH",
        // impactRange = "+50 to +80 points",
        // timeline = "60–90 days",
        rows,
        // totalOutstanding,
        totalImpact = "-100 to -130 points",
        negotiationOpportunityAccountsDetails,
        totals,
    } = data;

    const createAmountBreakUp = (accs) => {
        const list = accs.map(account => account.outstandingUnpaid);
        return list;
    };
    return (
        <div className="recommend-card">
            {/* Header */}
            <h1 className="recommend-title">
                RECOMMENDATION #{recommendationNo}: {heading}
            </h1>
            <div className="recommend-header">
                <span className="recommend-badge recommend-critical">
                    🔥 {priority}
                </span>
                <span className="recommend-pill">📈 Impact: {impactRange}</span>
                <span className="recommend-pill">⏱ {timeline}</span>
            </div>

            <h2 className="recommend-section-title">Your Current Situation</h2>

            <table className="recommend-table">
                <thead>
                    <tr>
                        <th>Bank / Lender</th>
                        <th>Account No</th>
                        <th>Loan Type</th>
                        <th>Settled On / Reported On</th>
                        <th>Original Amount(₹)</th>
                        <th>Outstanding Unpaid(₹)</th>
                        <th>Impact</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((acc, idx) => (
                        <tr key={idx}>
                            <td className="lenderName-with-acc">
                                <p>{acc.lenderName}</p>
                                <span></span>
                            </td>
                            <td>{acc.accountNo.slice(-8)} </td>
                            <td>{acc.loanType}</td>
                            <td>{acc.settledOn}</td>
                            <td>₹{acc.originalLoanAmount}</td>
                            <td>₹{acc.outstandingAmount}</td>
                            <td className="recommend-negative">{acc.impact}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="recommend-summary">
                <span><b>Total Outstanding:</b> {totals.totalOutstanding}</span>
                <span>
                    <b>Total Impact:</b>{" "}
                    <span className="recommend-negative">{totals.totalImpact}</span>
                </span>
            </div>

            <h2 className="recommend-section-title">What You Need To Do</h2>

            <ol className="recommend-steps">
                <li>Pay outstanding amounts in  full ({createAmountBreakUp(rows).map((i) => <b> {i}  </b>)})</li>
                <li>Obtain No Dues Certificate from each lender</li>
                <li>Request status update from <b>Settled</b> to <b>Closed</b></li>
                <li>Follow up with credit bureaus (CIBIL, Experian, Equifax)</li>
            </ol>

            <div className="recommend-info-box">
                💡 <b>Negotiation Opportunity:</b> : Banks often accept 50-70% of outstanding in case of genuine
                circumstances of their customers.
            </div>

            <table className="recommend-table">
                <thead>
                    <tr>
                        <th>Lender</th>
                        <th>Outstanding (₹)</th>
                        <th>Settlement Range(₹)</th>
                        <th>Savings(₹)</th>
                    </tr>
                </thead>
                <tbody>
                    {negotiationOpportunityAccountsDetails.map((row, idx) => (
                        <tr key={idx}>
                            <td>{row.lenderName}</td>
                            <td>₹{row.outstandingAmount}</td>
                            <td>₹{row.settlementLowerBound}- ₹{row.settlementUpperBound}</td>
                            <td className="recommend-positive">₹{row.savingsLowerBound}-₹{row.savingsUpperBound}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="recommend-cta">
                <button className="recommend-btn recommend-primary">
                    📞 Schedule Free CIBIL Cleanup Consultation
                </button>
                <button className="recommend-btn recommend-secondary">
                    💬 Connect with Settlement Specialist
                </button>
            </div>
        </div>
    );
};

const PaymentDiscipline = ({ data }) => {
    if (!data) return null;

    const {
        recommendationNo,
        heading,
        priority,
        impactRange,
        timeline,
        rows,
        totals,
        currentImpact = "-50 to -70 points",
        actionPlan,
        emiBreakdown,
        totalMonthly,
        threeMonthFunding,

        // heading = "Achieve 100% On-Time Payments",
        // priority = "CRITICAL",
        // impactRange = "+30 to +50 points",
        // timeline = "90 days",
    } = data;


    return (
        <div className="recommend-card">

            {/* Header */}
            <h1 className="recommend-title">
                RECOMMENDATION #{recommendationNo}:
                {heading}
            </h1>
            <div className="recommend-header">
                <span className="recommend-badge recommend-critical">
                    🔥 {priority}
                </span>
                <span className="recommend-pill">📈 Impact: {impactRange}</span>
                <span className="recommend-pill">⏱ {timeline}</span>
            </div>

            {/* Payment Record */}
            <h2 className="recommend-section-title">
                Your Last 90 Days Payment Record
            </h2>

            <table className="recommend-table">
                <thead>
                    <tr>
                        <th>Lender</th>
                        <th>Account No</th>
                        <th>Loan / Card Type</th>
                        <th>EMIs Due</th>
                        <th>Paid On-Time</th>
                        <th>Missed / Delayed</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, idx) => (
                        <tr key={idx}>
                            <td>{row.lenderName}</td>
                            <td>{row.accountNo.slice(-8)}</td>
                            <td>{row.loanType}</td>
                            <td>{row.emisDue}</td>
                            <td>{row.paidOnTime}</td>
                            <td>
                                <span
                                    className={
                                        row.missedDelayed > 0
                                            ? "recommend-dot recommend-red"
                                            : "recommend-dot recommend-green"
                                    }
                                />
                                {row.missedDelayed}
                            </td>
                        </tr>
                    ))}
                    <tr className="recommend-total-row">
                        <td><b>TOTAL</b></td>
                        <td>-</td>
                        <td>-</td>
                        <td>{totals.totalEmis}</td>
                        <td>{totals.paidOnTime}</td>
                        <td>
                            {totals.missedPayment} ({((totals.paidOnTime / totals.totalEmis) * 100).toFixed(2)} % On-Time)
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className="recommend-summary">
                <b>Current Impact:</b>{" "}
                <span className="recommend-negative">{currentImpact}</span>
            </div>

            {/* Action Plan */}
            <h2 className="recommend-section-title">
                Your 3-Step Action Plan
            </h2>

            <div className="recommend-pay-action-plan">
                {[
                    {
                        title: "Activate Reminders",
                        items: [
                            "Set phone reminders 2–3 days before each EMI",
                            "Activate Due Factory WhatsApp alerts"
                        ]
                    },
                    {
                        title: "Pre-Fund Your EMI Account",
                        items: [
                            "Keep 3 months of EMI amount as buffer",
                            "Avoid last-day payment failures"
                        ]
                    },
                    {
                        title: "Enable Auto-Pay",
                        items: [
                            "Enable full auto-pay for all credit cards",
                            "Set minimum due auto-pay as backup"
                        ]
                    }
                ].map((step, idx) => (
                    <div key={idx} className="recommend-step-block">
                        <div>STEP {idx + 1}: {step.title}</div>
                        <ul className="recommend-steps">
                            {step.items.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            {/* EMI Breakdown */}
            {/* <h2 className="recommend-section-title">
                Monthly EMI Breakdown
            </h2>

            <table className="recommend-table">
                <thead>
                    <tr>
                        <th>Account</th>
                        <th>Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {emiBreakdown.map((emi, idx) => (
                        <tr key={idx}>
                            <td>{emi.account}</td>
                            <td>{emi.amount}</td>
                        </tr>
                    ))}
                    <tr className="recommend-total-row">
                        <td><b>Total Monthly</b></td>
                        <td><b>{totalMonthly}</b></td>
                    </tr>
                </tbody>
            </table> */}

            {/* <div className="recommend-info-box">
                <b>3-Month Funding Required:</b> {threeMonthFunding}
                <br />
                <b>Action:</b> Transfer amount to EMI account today
            </div> */}

            {/* CTA */}
            <div className="recommend-cta">
                <button className="recommend-btn recommend-primary">
                    📲 Activate WhatsApp EMI Reminders
                </button>
                <button className="recommend-btn recommend-secondary">
                    🏦 Guide Me to Set Up Auto-Pay
                </button>
            </div>

        </div>
    );
};


const OverdueNormalization = ({ data }) => {
    if (!data) return null;

    const {
        recommendationNo,
        displayHeading,
        priority,
        impactRange,
        timeline,
        // priority = "CRITICAL",
        // impactRange = "+40 to +70 points",
        // timeline = "Immediate",
        categoryA,
        categoryB,
        categoryC
    } = data;
    const ctas = {
        primary: "I Want to Pay in Full – Call Me",
        secondary: "I Need Settlement Help – Connect Now",
    }

    const renderStatus = (status) => {
        const map = {
            CRITICAL: "recommend-red",
            URGENT: "recommend-red",
            ATTENTION: "recommend-yellow",
            ACT_NOW: "recommend-red",
            WRITTEN_OFF: "recommend-red",
            PRE_WRITE_OFF: "recommend-yellow",
            LEGAL_RISK: "recommend-red",
            ACTIVE: "recommend-green",
            null: "-"
        };

        return (
            <span className="recommend-status">
                <span className={`recommend-dot ${map[status]}`} />
                {status ? <>{status.replaceAll("_", " ")}</> : null}
            </span>
        );
    };

    return (
        <div className="recommend-card">

            {/* Header */}


            <h1 className="recommend-title">
                RECOMMENDATION #{recommendationNo}:
                {/* {displayHeading} */}
                Normalize Overdue Balances
            </h1>
            <div className="recommend-header">
                <span className="recommend-badge recommend-critical">🔥 {priority}</span>
                <span className="recommend-pill">📈 Impact: {impactRange}</span>
                <span className="recommend-pill">⏱ {timeline}</span>
            </div>
            {/* CATEGORY A */}


            {
                categoryA ? <>
                    <h2 className="recommend-section-title">
                        Category A: Less Than 90 Days Past Due
                    </h2>
                    <table className="recommend-table">
                        <thead>
                            <tr>
                                <th>Lender</th>
                                <th>Account No</th>
                                <th>Type</th>
                                <th>Outstanding Since (Last payement date)</th>
                                <th>Outstanding Amount(₹)</th>
                                <th>DPD</th>
                                <th>Interest / Month</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categoryA.accounts.map((row, idx) => (
                                <tr key={idx}>
                                    <td>{row.lender}</td>
                                    <td>{row.accountNo.slice(-8)}</td>
                                    <td>{row.type}</td>
                                    <td>{row.outstandingSince || !(row.outstandingSince === "") ? row.outstandingSince : "-"}</td>
                                    <td>{"₹" + row.outstandingAmount ?? "-"}</td>
                                    <td>{row.dpd}</td>
                                    <td>{row.monthlyInterest}</td>
                                    <td>{renderStatus(row.status)}</td>
                                </tr>
                            ))}
                            <tr className="recommend-total-row">
                                <td><b>TOTAL</b></td>
                                <td>-</td>
                                <td>-</td>
                                <td>-</td>
                                <td><b>{"₹" + categoryA.totalAmount}</b></td>
                                <td>-</td>
                                <td><b>{categoryA.totalInterest}</b></td>
                                <td>-</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="recommend-info-box">
                        <b>Options:</b>
                        <ul className="recommend-steps">
                            {categoryA.options.map((opt, i) => (
                                <li key={i}>{opt}</li>
                            ))}
                        </ul>
                    </div>
                </> : null
            }

            {categoryB ? <>
                {/* CATEGORY B */}
                <h2 className="recommend-section-title">
                    Category B: More Than 90 and less than 180 Days Past Due
                </h2>

                <table className="recommend-table">
                    <thead>
                        <tr>
                            <th>Lender</th>
                            <th>Account No</th>
                            <th>Type</th>
                            <th>Outstanding Since (Last payement date)</th>
                            <th>Outstanding Amount(₹)</th>
                            <th>DPD</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categoryB.accounts.map((row, idx) => (
                            <tr key={idx}>
                                <td>{row.lender}</td>
                                <td>{row.accountNo.slice(-8)}</td>
                                <td>{row.type}</td>
                                <td>{row.outstandingSince || !(row.outstandingSince === "") ? row.outstandingSince : "-"}</td>
                                <td>{"₹" + row.outstandingAmount ?? "-"}</td>
                                <td>{row.dpd}</td>
                                <td>{renderStatus(row.status)}</td>
                            </tr>
                        ))}
                        <tr className="recommend-total-row">
                            <td><b>TOTAL</b></td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td><b>{categoryB.totalAmount}</b></td>
                            <td>-</td>
                            <td>-</td>
                        </tr>
                    </tbody>
                </table>

                <div className="recommend-info-box">
                    <b>Options:</b>
                    <ul className="recommend-steps">
                        {categoryB.options.map((opt, i) => (
                            <li key={i}>{opt}</li>
                        ))}
                    </ul>
                </div>
            </> : null}

            {categoryC ? <>
                {/* CATEGORY C */}
                <h2 className="recommend-section-title">
                    Category C: Greater than 180 Days Past Due
                </h2>

                <table className="recommend-table">
                    <thead>
                        <tr>
                            <th>Lender</th>
                            <th>Account No</th>
                            <th>Type</th>
                            <th>Outstanding Since (Last payement date)</th>
                            <th>Outstanding Amount(₹)</th>
                            <th>DPD</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categoryC.accounts.map((row, idx) => (
                            <tr key={idx}>
                                <td>{row.lender}</td>
                                <td>{row.accountNo.slice(-8)}</td>
                                <td>{row.type}</td>
                                <td>{row.outstandingSince || !(row.outstandingSince === "") ? row.outstandingSince : "-"}</td>
                                <td>{"₹" + row.outstandingAmount ?? "-"}</td>
                                <td>{row.dpd}</td>
                                <td>{renderStatus(row.status)}</td>
                            </tr>
                        ))}
                        <tr className="recommend-total-row">
                            <td><b>TOTAL</b></td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td><b>{categoryC.totalAmount}</b></td>
                            <td>-</td>
                            <td>-</td>
                        </tr>
                    </tbody>
                </table>

                <div className="recommend-info-box">
                    <b>Options:</b>
                    <ul className="recommend-steps">
                        {categoryC.options.map((opt, i) => (
                            <li key={i}>{opt}</li>
                        ))}
                    </ul>
                </div>
            </> : null}

            {/* CTA */}
            <div className="recommend-cta">
                <button className="recommend-btn recommend-primary">
                    💰 {ctas.primary}
                </button>
                <button className="recommend-btn recommend-secondary">
                    🤝 {ctas.secondary}
                </button>
            </div>
        </div>
    );
};

const EnquiryControl = ({ data }) => {
    if (!data) return null;
    const {
        recommendationNo,
        heading,
        priority,
        impactRange,
        timeline,
        enquirySummary,
        currentImpact,
        freezeRules,
        explanation,
        cta,
    } = data;

    const statusColorMap = {
        CONCERNING: "recommend-yellow",
        TOO_MANY: "recommend-red",
        EXCESSIVE: "recommend-red",
    };

    return (
        <div className="recommend-card">

            {/* Header */}

            <h1 className="recommend-title">
                RECOMMENDATION #{recommendationNo}: {heading}
            </h1>
            <div className="recommend-header">
                <span className="recommend-badge recommend-warning">
                    🔥 {priority}
                </span>
                <span className="recommend-pill">📈 Impact: {impactRange}</span>
                <span className="recommend-pill">⏱ {timeline}</span>
            </div>

            {/* Enquiry Summary */}
            <h2 className="recommend-section-title">
                Your Recent Enquiries
            </h2>

            <table className="recommend-table">
                <thead>
                    <tr>
                        <th>Period</th>
                        <th>Enquiries</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {enquirySummary.map((row, idx) => (
                        <tr key={idx}>
                            <td>{row.period}</td>
                            <td>{row.count}</td>
                            <td>
                                <span className="recommend-status">
                                    <span
                                        className={`recommend-dot ${statusColorMap[row.status]}`}
                                    />
                                    {row.label}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="recommend-summary">
                <b>Current Impact:</b>{" "}
                <span className="recommend-negative">{currentImpact}</span>
            </div>

            {/* Action Plan */}
            <h2 className="recommend-section-title">
                What You Need To Do
            </h2>

            <div className="recommend-info-box recommend-danger-box">
                <b>COMPLETE 90-DAY CREDIT FREEZE</b>
                <ul className="recommend-steps">
                    {freezeRules.map((rule, idx) => (
                        <li key={idx}>❌ {rule}</li>
                    ))}
                </ul>
            </div>

            <p className="recommend-muted-text">
                <b>Why 90 Days?</b> Enquiries fall off the 'recent' scoring window after 90 days, allowing your credit score to recover naturally.
            </p>

            {/* CTA */}
            <div className="recommend-cta">
                <button className="recommend-btn recommend-primary">
                    📅 Set My 90-Day No-Enquiry Reminder
                </button>
            </div>
        </div>
    );
};

const OptimizeCreditMix = ({ data }) => {
    if (!data) return null;
    const {
        recommendationNo,
        heading,
        priority,
        impactRange,
        timeline,
        portfolio,
        assessment,
        futureActions,
        actionTracking,
        futureActionText
    } = data;

    const healthColorMap = {
        GOOD: "recommend-green",
        HIGH: "recommend-yellow",
        POOR: "recommend-red",
        MISSING: "recommend-red",
        EXCESSIVE: "recommend-red",
    };

    return (
        <div className="recommend-card">

            {/* Header */}

            <h1 className="recommend-title">
                RECOMMENDATION #{recommendationNo}: {heading}
            </h1>
            <div className="recommend-header">
                <span className="recommend-badge recommend-neutral">
                    ⭐ {priority}
                </span>
                <span className="recommend-pill">📈 Impact: {impactRange}</span>
                <span className="recommend-pill">⏱ {timeline}</span>
            </div>

            {/* Portfolio */}
            <h2 className="recommend-section-title">
                Your Current Credit Portfolio
            </h2>

            <table className="recommend-table">
                <thead>
                    <tr>
                        <th>Category</th>
                        <th>Count</th>
                        <th>Examples</th>
                        <th>Health</th>
                    </tr>
                </thead>
                <tbody>
                    {portfolio.map((row, idx) => (
                        <tr key={idx}>
                            <td>{row.category}</td>
                            <td>{row.count}</td>
                            <td>{row.examples}</td>
                            <td>
                                <span className="recommend-status">
                                    <span
                                        className={`recommend-dot ${healthColorMap[row.health]}`}
                                    />
                                    {
                                        row.health === "MISSING" ||
                                            row.health === "EXCESSIVE"
                                            ? "-" : null} {row.healthLabel}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* <div className="recommend-info-box">
                <b>Assessment:</b> {assessment}
            </div> */}

            {/* Future Actions */}
            <h2 className="recommend-section-title">
                Future Action <span className="recommend-muted-text">({futureActionText})</span>
            </h2>
            {futureActions ? <>
                <ul className="recommend-steps">
                    {futureActions.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
            </> : null}


        </div>
    );
};

const ZeroActiveCredit = ({ data }) => {
    if (!data) return null;

    const {
        recommendationNo,
        heading,
        priority,
        impactRange,
        timeline,
        currentStatus,
        warningNote,
        recommendedSteps,
        usageRules,
    } = data;
    const ctas = {
        primary: "Get Secured Card Recommendations",
        secondary: "WhatsApp Me Application Process",
    }

    return (
        <div className="recommend-card">

            {/* Header */}
            <h1 className="recommend-title">
                RECOMMENDATION #{recommendationNo}: {heading}
            </h1>
            <div className="recommend-header">
                <span className="recommend-badge recommend-critical">
                    🔥 {priority}
                </span>
                <span className="recommend-pill">📈 Impact: {impactRange}</span>
                <span className="recommend-pill">⏱ {timeline}</span>
            </div>

            {/* Current Situation */}
            <h2 className="recommend-section-title">Your Situation</h2>

            <table className="recommend-table">
                <thead>
                    <tr>
                        <th>Credit Type</th>
                        <th>Count</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {currentStatus.map((row, idx) => (
                        <tr key={idx}>
                            <td>{row.type}</td>
                            <td>{row.count}</td>
                            <td>
                                <span className="recommend-status">
                                    <span className="recommend-dot recommend-red" />
                                    {row.status}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className="recommend-info-box recommend-danger-box">
                {warningNote}
            </div>

            {/* Recommended Card */}
            <h2 className="recommend-section-title">
                Recommended Card
            </h2>

            {/* <div className="recommend-info-box">
                <b>{recommendedSteps.name}</b>
                <ul className="recommend-steps">
                    {recommendedSteps.details.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </ul>
            </div> */}

            <div className="recommend-pay-action-plan" style={{
                padding: 20,
                borderRadius: 10,
                background: "aliceblue"
            }}>
                {recommendedSteps.map((step, idx) => (
                    <div key={idx} className="recommend-step-block">
                        <div>{step.name}</div>
                        <ul className="recommend-steps">
                            {step.details.map((item, i) => (
                                <li key={i}>{item}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            {/* Usage Rules */}
            <h2 className="recommend-section-title">Usage Rules</h2>

            <table className="recommend-table">
                <thead>
                    <tr>
                        <th>Rule</th>
                        <th>Action</th>
                        <th>Why</th>
                    </tr>
                </thead>
                <tbody>
                    {usageRules.map((rule, idx) => (
                        <tr key={idx}>
                            <td>Rule {idx + 1}</td>
                            <td>{rule.action}</td>
                            <td>{rule.reason}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* CTA */}
            <div className="recommend-cta">
                <button className="recommend-btn recommend-primary">
                    💳 {ctas.primary}
                </button>
                <button className="recommend-btn recommend-secondary">
                    📲 {ctas.secondary}
                </button>
            </div>

        </div>
    );
};

const CreditMaintenance = ({ data }) => {
    if (!data) return null;

    const {
        recommendationNo,
        heading,
        priority,
        subtitle,
        eligibility,
        supportingMetrics,
        calculationExplanation,
        supportingTable,
        guidelines,
        actionTracking,
        cta,
    } = data;

    return (
        <div className="recommend-card">

            <h1 className="recommend-title">
                RECOMMENDATION #{recommendationNo}: {heading}
            </h1>

            <div className="recommend-header">
                <span className="recommend-badge recommend-neutral">
                    🛡️ {priority}
                </span>
                <span className="recommend-pill">
                    ✅ Eligibility: {eligibility}
                </span>
            </div>

            <p className="recommend-muted-text">{subtitle}</p>

            {/* WHY THIS APPLIES */}
            {supportingMetrics && (
                <>
                    <h2 className="recommend-section-title">Why This Recommendation Applies</h2>
                    <table className="recommend-table">
                        <thead>
                            <tr>
                                <th>Metric</th>
                                <th>Your Value</th>
                                <th>Healthy Range</th>
                            </tr>
                        </thead>
                        <tbody>
                            {supportingMetrics.map((m, i) => (
                                <tr key={i}>
                                    <td>{m.metric}</td>
                                    <td>{m.current}</td>
                                    <td>{m.ideal}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            {calculationExplanation && (
                <div className="recommend-info-box">
                    <b>How this impacts your score:</b>
                    <p>{calculationExplanation}</p>
                </div>
            )}

            {/* OPTIONAL SUPPORT TABLE */}
            {supportingTable && (
                <>
                    <h2 className="recommend-section-title">{supportingTable.title}</h2>
                    <table className="recommend-table">
                        <thead>
                            <tr>
                                {supportingTable.columns.map((c, i) => (
                                    <th key={i}>{c}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {supportingTable.rows.map((r, ri) => (
                                <tr key={ri}>
                                    {r.map((cell, ci) => (
                                        <td key={ci}>{cell}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}

            {/* BEST PRACTICES */}
            <h2 className="recommend-section-title">Best Practices</h2>
            <ul className="recommend-steps">
                {guidelines.map((g, i) => (
                    <li key={i}>{g}</li>
                ))}
            </ul>

            {/* TRACKING */}
            {actionTracking?.length > 0 && (
                <>
                    <h2 className="recommend-section-title">Action Tracking</h2>
                    <ul className="recommend-steps">
                        {actionTracking.map((a, i) => (
                            <li key={i}>
                                [{a.status}] <b>{a.period}:</b> {a.task}
                            </li>
                        ))}
                    </ul>
                </>
            )}

            {/* CTA */}
            {cta && (
                <div className="recommend-cta">
                    {cta.primary && (
                        <button className="recommend-btn recommend-primary">
                            {cta.primary}
                        </button>
                    )}
                    {cta.secondary && (
                        <button className="recommend-btn recommend-secondary">
                            {cta.secondary}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

/* ------------------ MAIN SCREEN ------------------ */

function RecommendationScreen() {

    const [list, setList] = useState([]);        // temporary list
    const [selectedPhone, setSelectedPhone] = useState("");
    const [reportNotFound, setReportNotFound] = useState(false);
    const [data, setData] = useState({
        DEROGATORY_CLEANUP: null,
        PAYMENT_DISCIPLINE: null,
        OVERDUE_NORMALIZATION: null,
        ENQUIRY_CONTROL: null,
        OPTIMIZE_CREDIT_MIX: null,
        ZERO_ACTIVE_CREDIT: null,
    });      // response data
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    /* -------------------------
       1. Load temporary list
       ------------------------- */
    useEffect(() => {
        // This can be replaced with an API call
        const tempList = [
            { key: "k15", phone: "7503537010", score: 479 },
            { key: "k1", phone: "7007803923", score: 758 },
            { key: "k2", phone: "8700564551", score: 619 },
            { key: "k3", phone: "6206061985", score: 433 },
            { key: "k4", phone: "7033089630", score: 491 },
            { key: "k5", phone: "7683032926", score: 785 },
            { key: "k6", phone: "9099028911", score: 800 },
            { key: "k7", phone: "8630040546", score: 696 },
            { key: "k8", phone: "9545126030", score: 775 },
            { key: "k9", phone: "7042892104", score: 596 },
            { key: "k10", phone: "9205116154", score: 819 },
            { key: "k11", phone: "7719001110", score: 857 },
            { key: "k12", phone: "6398937680", score: 581 },
            { key: "k13", phone: "9608522063", score: 655 },
            { key: "k14", phone: "9643662919", score: 529 },
        ];


        setList(tempList);
    }, []);

    /* -------------------------
       2. Handle API Call
       ------------------------- */
    const handleCheck = async () => {
        if (!selectedPhone) {
            setError("Please select a phone number");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const response = await axios.post(
                `https://uat.duefactory.com/tdf/api/recommendation/pull/${selectedPhone}`   // 🔁 replace with real API

            );
            if (response.data) {
                setData(response.data);
                setReportNotFound(false)
            }
            if (Object.keys(response.data).length === 0) {
                setReportNotFound(true)
            }
            // save API response
        } catch (err) {
            setError("Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };

    // const data = {
    //     DEROGATORY_CLEANUP: {
    //         recommendationNo: 1,
    //         heading: "Clean Up Settled Accounts",
    //         priority: "HIGH",
    //         impactRange: "+50 to +80 points",
    //         timeline: "60–90 days",
    //         accounts: [
    //             {
    //                 lender: "ICICI Bank",
    //                 loanType: "Personal Loan",
    //                 reportedDate: "15-Mar-2024",
    //                 originalAmount: "₹2,50,000",
    //                 outstandingUnpaid: "₹75,000",
    //                 impact: "-60 to -80 points",
    //             },
    //             {
    //                 lender: "Bajaj Finserv",
    //                 loanType: "Consumer Loan",
    //                 reportedDate: "22-Aug-2023",
    //                 originalAmount: "₹85,000",
    //                 outstandingUnpaid: "₹25,000",
    //                 impact: "-40 to -50 points",
    //             },
    //         ],

    //         totalOutstanding: "₹1,00,000",
    //         totalImpact: "-100 to -130 points",
    //         negotiationOpportunityAccountsDetails: [
    //             {
    //                 lender: "ICICI Bank",
    //                 outstanding: "₹75,000",
    //                 negotiationRange: "₹40,000 – ₹52,500",
    //                 savingRange: "₹22,500 – ₹35,000",
    //             },
    //             {
    //                 lender: "Bajaj Finserv",
    //                 outstanding: "₹25,000",
    //                 negotiationRange: "₹12,500 – ₹17,500",
    //                 savingRange: "₹7,500 – ₹12,500",
    //             },
    //         ],
    //     },
    //     PAYMENT_DISCIPLINE: {
    //         recommendationNo: 2,
    //         heading: "Achieve 100% On-Time Payments",
    //         priority: "CRITICAL",
    //         impactRange: "+30 to +50 points",
    //         timeline: "90 days",
    //         paymentRecords: [
    //             {
    //                 lender: "ICICI Bank",
    //                 accountType: "Personal Loan",
    //                 emisDue: 3,
    //                 paidOnTime: 2,
    //                 missedDelayed: 1
    //             },
    //             {
    //                 lender: "ICICI Bank",
    //                 accountType: "Credit Card",
    //                 emisDue: 3,
    //                 paidOnTime: 2,
    //                 missedDelayed: 1
    //             },
    //             {
    //                 lender: "Mahindra Finance",
    //                 accountType: "Vehicle Loan",
    //                 emisDue: 3,
    //                 paidOnTime: 2,
    //                 missedDelayed: 1
    //             },
    //             {
    //                 lender: "HDFC Bank",
    //                 accountType: "Credit Card",
    //                 emisDue: 3,
    //                 paidOnTime: 2,
    //                 missedDelayed: 1
    //             },
    //             {
    //                 lender: "Bank of Baroda",
    //                 accountType: "Home Loan",
    //                 emisDue: 3,
    //                 paidOnTime: 3,
    //                 missedDelayed: 0
    //             },
    //             {
    //                 lender: "SBI",
    //                 accountType: "Credit Card",
    //                 emisDue: 3,
    //                 paidOnTime: 3,
    //                 missedDelayed: 0
    //             }
    //         ],

    //         totalSummary: {
    //             totalEmis: 18,
    //             onTime: 14,
    //             missed: 4,
    //             onTimePercentage: "78% on-time"
    //         },

    //         currentImpact: "-50 to -70 points",
    //         emiBreakdown: [
    //             { account: "ICICI Personal Loan", amount: "₹8,500" },
    //             { account: "ICICI Credit Card", amount: "₹3,200" },
    //             { account: "Mahindra Vehicle Loan", amount: "₹12,800" },
    //             { account: "HDFC Credit Card", amount: "₹4,500" },
    //             { account: "BOB Home Loan", amount: "₹18,500" },
    //             { account: "SBI Credit Card", amount: "₹2,800" }
    //         ],

    //         totalMonthly: "₹50,300",
    //         threeMonthFunding: "₹1,50,900"
    //     },
    //     OVERDUE_NORMALIZATION: {
    //         recommendationNo: 3,
    //         heading: "Normalize Overdue Balances",
    //         priority: "CRITICAL",
    //         impactRange: "+40 to +70 points",
    //         timeline: "Immediate",

    //         categoryA: {
    //             accounts: [
    //                 {
    //                     lender: "Standard Chartered",
    //                     type: "Credit Card",
    //                     outstandingSince: "15-Nov-2025",
    //                     amount: "₹45,000",
    //                     dpd: 60,
    //                     monthlyInterest: "₹1,350",
    //                     status: "CRITICAL",
    //                 },
    //                 {
    //                     lender: "Kotak Mahindra",
    //                     type: "Personal Loan",
    //                     outstandingSince: "01-Oct-2025",
    //                     amount: "₹1,20,000",
    //                     dpd: 67,
    //                     monthlyInterest: "₹2,400",
    //                     status: "URGENT",
    //                 },
    //                 {
    //                     lender: "HDFC Bank",
    //                     type: "Credit Card",
    //                     outstandingSince: "20-Dec-2025",
    //                     amount: "₹28,000",
    //                     dpd: 76,
    //                     monthlyInterest: "₹840",
    //                     status: "ATTENTION",
    //                 },
    //             ],
    //             totalAmount: "₹1,93,000",
    //             totalInterest: "₹4,590",
    //             options: [
    //                 "Pay in Full: ₹1,93,000 → Best for score, stops interest",
    //                 "Settle: ₹1,06,000–₹1,33,000 (55–70%) → Saves ₹60K–₹87K",
    //             ],
    //         },

    //         categoryB: {
    //             accounts: [
    //                 {
    //                     lender: "IDFC First Bank",
    //                     type: "Personal Loan",
    //                     outstandingSince: "15-Jun-2025",
    //                     amount: "₹2,50,000",
    //                     dpd: 210,
    //                     status: "WRITTEN_OFF",
    //                 },
    //                 {
    //                     lender: "SBI Credit Card",
    //                     type: "Credit Card",
    //                     outstandingSince: "22-May-2025",
    //                     amount: "₹65,000",
    //                     dpd: 235,
    //                     status: "WRITTEN_OFF",
    //                 },
    //                 {
    //                     lender: "Bajaj Finance",
    //                     type: "Consumer Loan",
    //                     outstandingSince: "10-Jul-2025",
    //                     amount: "₹95,000",
    //                     dpd: 125,
    //                     status: "PRE_WRITE_OFF",
    //                 },
    //             ],
    //             totalAmount: "₹4,10,000",
    //             options: [
    //                 "One-Time Settlement: ₹1,45,000–₹1,86,000 (35–45%) → Saves ₹2.24L–₹2.65L",
    //                 "Request payment plan from bank: ₹85,000 downpayment + ₹32,500/month × 10 months",
    //             ],
    //         },
    //     },
    //     ENQUIRY_CONTROL: {
    //         recommendationNo: 4,
    //         heading: "Stop New Credit Enquiries",
    //         priority: "HIGH",
    //         impactRange: "+15 to +25 points",
    //         timeline: "90 days",

    //         enquirySummary: [
    //             {
    //                 period: "Last 30 days",
    //                 count: 2,
    //                 status: "CONCERNING",
    //                 label: "Concerning",
    //             },
    //             {
    //                 period: "Last 90 days",
    //                 count: 6,
    //                 status: "TOO_MANY",
    //                 label: "Too Many",
    //             },
    //             {
    //                 period: "Last 180 days",
    //                 count: 9,
    //                 status: "EXCESSIVE",
    //                 label: "Excessive",
    //             },
    //         ],

    //         currentImpact: "-30 to -45 points",

    //         freezeRules: [
    //             "No new credit cards",
    //             "No personal loans",
    //             "No vehicle or home loans",
    //             "No credit limit increases",
    //             "No EMI schemes at stores",
    //             "No BNPL apps (Simpl, LazyPay, ZestMoney)",
    //         ],

    //     },
    //     OPTIMIZE_CREDIT_MIX: {
    //         recommendationNo: 5,
    //         heading: "Optimize Credit Mix",
    //         priority: "MEDIUM",
    //         impactRange: "+10 to +20 points",
    //         timeline: "6–12 months",
    //         portfolio: [
    //             {
    //                 category: "Secured Loans",
    //                 count: 2,
    //                 examples: "Home Loan, Car Loan",
    //                 health: "GOOD",
    //                 healthLabel: "Good",
    //             },
    //             {
    //                 category: "Unsecured Loans",
    //                 count: 3,
    //                 examples: "Personal Loans",
    //                 health: "HIGH",
    //                 healthLabel: "High",
    //             },
    //             {
    //                 category: "Credit Cards",
    //                 count: 3,
    //                 examples: "ICICI, HDFC, SBI",
    //                 health: "GOOD",
    //                 healthLabel: "Good",
    //             },
    //         ],

    //         assessment:
    //             "Your credit mix is DECENT. Focus on Priority Recommendations first.",
    //         futureActionText: "Only After Score Reaches 720+",
    //         futureActions: [
    //             "Consider small secured loan to pay off high-interest unsecured debt",
    //             "OR take ₹50K FD-backed loan as a credit builder",
    //         ],
    //     },
    //     ZERO_ACTIVE_CREDIT: {
    //         recommendationNo: 6,
    //         heading: "Get Secured Credit Card",
    //         priority: "CRITICAL",
    //         impactRange: "+40 to +60 points",
    //         timeline: "6 months",
    //         currentStatus: [
    //             {
    //                 type: "Active Loans",
    //                 count: 0,
    //                 status: "None",
    //             },
    //             {
    //                 type: "Active Credit Cards",
    //                 count: 0,
    //                 status: "None",
    //             },
    //         ],

    //         warningNote:
    //             "Without active credit, your score will continue declining. A secured credit card restarts your credit journey.",

    //         recommendedSteps: {
    //             name: "SBI SimplyClick Secured",
    //             details: [
    //                 "FD Required: ₹10,000 (lowest in market)",
    //                 "Credit Limit: ₹8,000 (80% of FD)",
    //                 "Annual Fee: ₹499",
    //                 "FD Interest: 6% p.a.",
    //             ],
    //         },

    //         usageRules: [
    //             {
    //                 action: "Use ₹2,000–₹5,000 per month",
    //                 reason: "Shows regular activity",
    //             },
    //             {
    //                 action: "Keep utilization under 30%",
    //                 reason: "Maintains healthy credit ratio",
    //             },
    //             {
    //                 action: "Pay FULL amount every month",
    //                 reason: "Builds perfect repayment history",
    //             },
    //             {
    //                 action: "Set up auto-pay",
    //                 reason: "Guarantees on-time payment",
    //             },
    //         ],
    //     },


    //     SCORE_STABILITY: {
    //         recommendationNo: 7,
    //         heading: "Protect and Maintain Your Good Score",
    //         priority: "LOW",
    //         subtitle: "Your credit score is healthy. The goal now is stability, not change.",
    //         eligibility: "Score ≥ 700 and no corrective issues",

    //         supportingMetrics: [
    //             { metric: "Current Credit Score", current: "735", ideal: "700+" },
    //             { metric: "Late Payments (12 months)", current: "0", ideal: "0" },
    //             { metric: "Credit Utilization", current: "24%", ideal: "< 30%" },
    //         ],

    //         calculationExplanation:
    //             "At scores above 700, aggressive actions add volatility without meaningful upside. Maintaining stability protects existing gains.",

    //         guidelines: [
    //             "Avoid new loans or cards unless absolutely necessary",
    //             "Pay all EMIs and cards on time",
    //             "Keep utilization under 30%",
    //             "Do not close old accounts",
    //         ],

    //         actionTracking: [
    //             { status: " ", period: "Monthly", task: "Review score and payment history" },
    //         ],

    //         cta: {
    //             primary: "View Monthly Score Health",
    //             secondary: "Enable Stability Alerts",
    //         },
    //     },

    //     CREDIT_GROWTH: {
    //         recommendationNo: 8,
    //         heading: "Increase Your Credit Limit Responsibly",
    //         priority: "LOW",
    //         subtitle: "Higher limits reduce utilization when managed correctly.",
    //         eligibility: "Utilization < 25%, stable payments",

    //         supportingMetrics: [
    //             { metric: "Total Credit Limit", current: "₹3,00,000", ideal: "—" },
    //             { metric: "Monthly Spend", current: "₹72,000", ideal: "< 30% limit" },
    //             { metric: "Utilization", current: "24%", ideal: "< 30%" },
    //         ],

    //         calculationExplanation:
    //             "Increasing limit to ₹4,00,000 with same spend reduces utilization from 24% → 18%, improving score stability.",

    //         supportingTable: {
    //             title: "Utilization Impact Example",
    //             columns: ["Scenario", "Limit", "Spend", "Utilization"],
    //             rows: [
    //                 ["Current", "₹3,00,000", "₹72,000", "24%"],
    //                 ["After Increase", "₹4,00,000", "₹72,000", "18%"],
    //             ],
    //         },

    //         guidelines: [
    //             "Request increase only from existing banks",
    //             "Never request multiple increases",
    //             "Do not increase spending after limit increase",
    //         ],

    //         actionTracking: [
    //             { status: " ", period: "Quarterly", task: "Check eligibility for one increase" },
    //         ],

    //         cta: {
    //             primary: "Check Limit Increase Eligibility",
    //             secondary: "Simulate Utilization Impact",
    //         },
    //     },

    //     CREDIT_PORTFOLIO_MATURITY: {
    //         recommendationNo: 9,
    //         heading: "Keep Your Oldest Accounts Open",
    //         priority: "LOW",
    //         subtitle: "Account age strengthens score consistency.",
    //         eligibility: "Oldest account ≥ 3 years",

    //         supportingMetrics: [
    //             { metric: "Oldest Account Age", current: "6.2 years", ideal: "3+ years" },
    //             { metric: "Average Account Age", current: "4.1 years", ideal: "Increasing" },
    //         ],

    //         calculationExplanation:
    //             "Closing old accounts reduces average age, which can cause unnecessary score drops.",

    //         guidelines: [
    //             "Never close your oldest account",
    //             "Use oldest card once every 6 months",
    //             "Always pay full balance",
    //         ],

    //         actionTracking: [
    //             { status: " ", period: "Every 6 months", task: "Ensure oldest account remains active" },
    //         ],

    //         cta: {
    //             primary: "Mark Oldest Account as Protected",
    //         },
    //     },

    //     STRATEGIC_CREDIT_USAGE: {
    //         recommendationNo: 10,
    //         heading: "Use Credit Strategically, Not Impulsively",
    //         priority: "LOW",
    //         subtitle: "Predictable usage improves lender confidence.",
    //         eligibility: "Utilization consistently < 30%",

    //         supportingMetrics: [
    //             { metric: "Avg Utilization (3 months)", current: "26%", ideal: "< 30%" },
    //             { metric: "Missed Payments", current: "0", ideal: "0" },
    //         ],

    //         calculationExplanation:
    //             "Stable month-to-month usage is rewarded more than sporadic high spends.",

    //         guidelines: [
    //             "Use credit only for planned expenses",
    //             "Avoid EMIs for discretionary purchases",
    //             "Never revolve balances",
    //         ],

    //         actionTracking: [
    //             { status: " ", period: "Monthly", task: "Review utilization trend" },
    //         ],

    //         cta: {
    //             primary: "View Usage Discipline Report",
    //         },
    //     },

    //     FUTURE_READINESS: {
    //         recommendationNo: 11,
    //         heading: "Stay Ready for Major Loan Approvals",
    //         priority: "LOW",
    //         subtitle: "Preparation today enables faster approvals tomorrow.",
    //         eligibility: "Score ≥ 720 with clean report",

    //         supportingMetrics: [
    //             { metric: "Credit Score", current: "742", ideal: "720+" },
    //             { metric: "Recent Enquiries (6 months)", current: "0", ideal: "0–1" },
    //         ],

    //         calculationExplanation:
    //             "Banks prefer profiles with zero recent enquiries and stable behavior before large loans.",

    //         guidelines: [
    //             "Avoid new credit 6 months before major loan",
    //             "Clear all minor issues in advance",
    //             "Keep documents consistent",
    //         ],

    //         actionTracking: [
    //             { status: " ", period: "Before Loan", task: "Run loan readiness checklist" },
    //         ],

    //         cta: {
    //             primary: "Run Loan Readiness Check",
    //         },
    //     },

    //     CREDIT_MONITORING: {
    //         recommendationNo: 12,
    //         heading: "Monitor Your Credit Report Monthly",
    //         priority: "LOW",
    //         subtitle: "Early detection prevents long-term damage.",
    //         eligibility: "No disputes, stable profile",

    //         supportingMetrics: [
    //             { metric: "Active Disputes", current: "0", ideal: "0" },
    //             { metric: "Last Report Check", current: "28 days ago", ideal: "≤ 30 days" },
    //         ],

    //         calculationExplanation:
    //             "Incorrect reporting can silently hurt your score if not caught early.",

    //         guidelines: [
    //             "Check credit report every month",
    //             "Report incorrect data immediately",
    //             "Verify all closed accounts",
    //         ],

    //         actionTracking: [
    //             { status: " ", period: "Monthly", task: "Review reports across all bureaus" },
    //         ],

    //         cta: {
    //             primary: "Enable Monthly Credit Monitoring",
    //             secondary: "Download Latest Credit Report",
    //         },
    //     },
    // };

    // const data = {
    //     DEROGATORY_CLEANUP: {
    //         recommendationNo: 1,
    //         heading: "Clean Up Settled Accounts",
    //         priority: "HIGH",
    //         impactRange: "+50 to +80 points",
    //         timeline: "60–90 days",

    //         accounts: [
    //             {
    //                 lender: "ICICI Bank",
    //                 loanType: "Personal Loan",
    //                 reportedDate: "15-Mar-2024",
    //                 originalAmount: "₹2,50,000",
    //                 outstandingUnpaid: "₹75,000",
    //                 impact: "-60 to -80 points",
    //             },
    //             {
    //                 lender: "Bajaj Finserv",
    //                 loanType: "Consumer Loan",
    //                 reportedDate: "22-Aug-2023",
    //                 originalAmount: "₹85,000",
    //                 outstandingUnpaid: "₹25,000",
    //                 impact: "-40 to -50 points",
    //             },
    //             {
    //                 lender: "HDFC Bank",
    //                 loanType: "Credit Card",
    //                 reportedDate: "10-Jan-2024",
    //                 originalAmount: "₹60,000",
    //                 outstandingUnpaid: "₹18,000",
    //                 impact: "-25 to -35 points",
    //             },
    //         ],

    //         totalOutstanding: "₹1,18,000",
    //         totalImpact: "-125 to -165 points",

    //         negotiationOpportunityAccountsDetails: [
    //             {
    //                 lender: "ICICI Bank",
    //                 outstanding: "₹75,000",
    //                 negotiationRange: "₹40,000 – ₹52,500",
    //                 savingRange: "₹22,500 – ₹35,000",
    //             },
    //             {
    //                 lender: "Bajaj Finserv",
    //                 outstanding: "₹25,000",
    //                 negotiationRange: "₹12,500 – ₹17,500",
    //                 savingRange: "₹7,500 – ₹12,500",
    //             },
    //             {
    //                 lender: "HDFC Bank",
    //                 outstanding: "₹18,000",
    //                 negotiationRange: "₹9,000 – ₹12,000",
    //                 savingRange: "₹6,000 – ₹9,000",
    //             },
    //         ],
    //     },

    //     PAYMENT_DISCIPLINE: {
    //         recommendationNo: 2,
    //         heading: "Achieve 100% On-Time Payments",
    //         priority: "CRITICAL",
    //         impactRange: "+30 to +50 points",
    //         timeline: "90 days",

    //         paymentRecords: [
    //             { lender: "ICICI Bank", accountType: "Personal Loan", emisDue: 3, paidOnTime: 2, missedDelayed: 1 },
    //             { lender: "Mahindra Finance", accountType: "Vehicle Loan", emisDue: 3, paidOnTime: 2, missedDelayed: 1 },
    //             { lender: "HDFC Bank", accountType: "Credit Card", emisDue: 3, paidOnTime: 2, missedDelayed: 1 },
    //             { lender: "ICICI Bank", accountType: "Credit Card", emisDue: 3, paidOnTime: 3, missedDelayed: 0 },
    //             { lender: "Bank of Baroda", accountType: "Home Loan", emisDue: 3, paidOnTime: 3, missedDelayed: 0 },
    //             { lender: "SBI", accountType: "Credit Card", emisDue: 3, paidOnTime: 3, missedDelayed: 0 },
    //         ],

    //         totalSummary: {
    //             totalEmis: 18,
    //             onTime: 15,
    //             missed: 3,
    //             onTimePercentage: "83% on-time",
    //         },

    //         currentImpact: "-45 to -60 points",

    //         emiBreakdown: [
    //             { account: "ICICI Personal Loan", amount: "₹8,500" },
    //             { account: "Mahindra Vehicle Loan", amount: "₹12,800" },
    //             { account: "BOB Home Loan", amount: "₹18,500" },
    //             { account: "HDFC Credit Card", amount: "₹4,500" },
    //             { account: "ICICI Credit Card", amount: "₹3,200" },
    //             { account: "SBI Credit Card", amount: "₹2,800" },
    //         ],

    //         totalMonthly: "₹50,300",
    //         threeMonthFunding: "₹1,50,900",
    //     },

    //     OVERDUE_NORMALIZATION: {
    //         recommendationNo: 3,
    //         heading: "Normalize Overdue Balances",
    //         priority: "CRITICAL",
    //         impactRange: "+40 to +70 points",
    //         timeline: "Immediate",

    //         categoryA: {
    //             accounts: [
    //                 {
    //                     lender: "Kotak Mahindra",
    //                     type: "Personal Loan",
    //                     outstandingSince: "01-Oct-2025",
    //                     amount: "₹1,20,000",
    //                     dpd: 67,
    //                     monthlyInterest: "₹2,400",
    //                     status: "URGENT",
    //                 },
    //                 {
    //                     lender: "Standard Chartered",
    //                     type: "Credit Card",
    //                     outstandingSince: "15-Nov-2025",
    //                     amount: "₹45,000",
    //                     dpd: 60,
    //                     monthlyInterest: "₹1,350",
    //                     status: "CRITICAL",
    //                 },
    //                 {
    //                     lender: "HDFC Bank",
    //                     type: "Credit Card",
    //                     outstandingSince: "20-Dec-2025",
    //                     amount: "₹28,000",
    //                     dpd: 76,
    //                     monthlyInterest: "₹840",
    //                     status: "ATTENTION",
    //                 },
    //             ],

    //             totalAmount: "₹1,93,000",
    //             totalInterest: "₹4,590",

    //             options: [
    //                 "Pay in full ₹1,93,000 → Stops interest, fastest score recovery",
    //                 "Settle ₹1,06,000–₹1,33,000 → Save ₹60K–₹87K, slower recovery",
    //             ],
    //         },

    //         categoryB: {
    //             accounts: [
    //                 {
    //                     lender: "IDFC First Bank",
    //                     type: "Personal Loan",
    //                     outstandingSince: "15-Jun-2025",
    //                     amount: "₹2,50,000",
    //                     dpd: 210,
    //                     status: "WRITTEN_OFF",
    //                 },
    //                 {
    //                     lender: "Bajaj Finance",
    //                     type: "Consumer Loan",
    //                     outstandingSince: "10-Jul-2025",
    //                     amount: "₹95,000",
    //                     dpd: 195,
    //                     status: "PRE_WRITE_OFF",
    //                 },
    //                 {
    //                     lender: "SBI Credit Card",
    //                     type: "Credit Card",
    //                     outstandingSince: "22-May-2025",
    //                     amount: "₹65,000",
    //                     dpd: 235,
    //                     status: "WRITTEN_OFF",
    //                 },
    //             ],

    //             totalAmount: "₹4,10,000",

    //             options: [
    //                 "One-time settlement ₹1,45,000–₹1,86,000 → Save ₹2.24L–₹2.65L",
    //                 "Payment plan ₹85,000 down + ₹32,500/month × 10 months",
    //             ],
    //         },
    //     },

    //     ENQUIRY_CONTROL: {
    //         recommendationNo: 4,
    //         heading: "Stop New Credit Enquiries",
    //         priority: "HIGH",
    //         impactRange: "+15 to +25 points",
    //         timeline: "90 days",

    //         enquirySummary: [
    //             { period: "Last 30 days", count: 2, status: "CONCERNING", label: "Acceptable but watch closely" },
    //             { period: "Last 90 days", count: 6, status: "TOO_MANY", label: "Hurting score" },
    //             { period: "Last 180 days", count: 9, status: "EXCESSIVE", label: "Severe negative impact" },
    //         ],

    //         currentImpact: "-30 to -45 points",

    //         freezeRules: [
    //             "No new credit cards or loans",
    //             "No BNPL / pay-later apps",
    //             "No credit limit increase requests",
    //             "No store EMI financing",
    //         ],
    //     },

    //     OPTIMIZE_CREDIT_MIX: {
    //         recommendationNo: 5,
    //         heading: "Optimize Credit Mix",
    //         priority: "MEDIUM",
    //         impactRange: "+10 to +20 points",
    //         timeline: "6–12 months",

    //         portfolio: [
    //             {
    //                 category: "Secured Loans",
    //                 count: 2,
    //                 examples: "Home Loan, Vehicle Loan",
    //                 health: "GOOD",
    //                 healthLabel: "Stable",
    //             },
    //             {
    //                 category: "Unsecured Loans",
    //                 count: 3,
    //                 examples: "Personal Loans",
    //                 health: "HIGH",
    //                 healthLabel: "Overweight",
    //             },
    //             {
    //                 category: "Credit Cards",
    //                 count: 3,
    //                 examples: "ICICI, HDFC, SBI",
    //                 health: "GOOD",
    //                 healthLabel: "Balanced",
    //             },
    //         ],

    //         assessment:
    //             "Credit mix is acceptable. Do NOT add new credit until high-risk items are resolved.",

    //         futureActionText: "Only After Score Reaches 720+",

    //         futureActions: [
    //             "Use secured loan only to replace high-interest unsecured debt",
    //             "Avoid adding multiple new products",
    //         ],
    //     },

    //     ZERO_ACTIVE_CREDIT: {
    //         recommendationNo: 6,
    //         heading: "Get Secured Credit Card",
    //         priority: "CRITICAL",
    //         impactRange: "+40 to +60 points",
    //         timeline: "6 months",

    //         currentStatus: [
    //             { type: "Active Loans", count: 0, status: "None" },
    //             { type: "Active Credit Cards", count: 0, status: "None" },
    //         ],

    //         warningNote:
    //             "Zero active credit causes score decay. One secured card immediately restarts score movement.",

    //         recommendedSteps: {
    //             name: "SBI SimplyClick Secured",
    //             details: [
    //                 "FD ₹10,000 → Credit limit ₹8,000",
    //                 "Annual fee ₹499",
    //                 "FD earns ~6% interest",
    //                 "Upgrade to unsecured possible after 6–9 months",
    //             ],
    //         },

    //         usageRules: [
    //             { action: "Spend ₹2,000–₹4,000 monthly", reason: "Shows consistent usage" },
    //             { action: "Keep utilization under 30%", reason: "Protects score" },
    //             { action: "Pay full bill before due date", reason: "Builds clean repayment history" },
    //             { action: "Enable auto-pay", reason: "Eliminates miss risk" },
    //         ],
    //     },
    // };

    const RecommendationCategory = (type, data) => {
        switch (type) {
            case "DEROGATORY_CLEANUP":
                return <DerogatoryCleanup data={data} />;
            case "PAYMENT_DISCIPLINE":
                return <PaymentDiscipline data={data} />;
            case "OVERDUE_NORMALIZATION":
                return <OverdueNormalization data={data} />;
            case "ENQUIRY_CONTROL":
                return <EnquiryControl data={data} />;
            case "OPTIMIZE_CREDIT_MIX":
                return <OptimizeCreditMix data={data} />;
            case "ZERO_ACTIVE_CREDIT":
                return <ZeroActiveCredit data={data} />;
            case "SCORE_STABILITY":
            case "CREDIT_GROWTH":
            case "CREDIT_PORTFOLIO_MATURITY":
            case "STRATEGIC_CREDIT_USAGE":
            case "FUTURE_READINESS":
            case "CREDIT_MONITORING":
                return <CreditMaintenance data={data} />;
            default:
                return null;
        }
    };

    return <>
        {/* <div>
            <div style={{ maxWidth: 420 }}>
                <label>
                    Select Phone Number
                    <select
                        value={selectedPhone}
                        onChange={(e) => setSelectedPhone(e.target.value)}
                        style={{ display: "block", width: "100%", marginTop: 6 }}
                    >
                        <option value="">-- Select --</option>
                        {list.map((item) => (
                            <option key={item.key} value={item.phone}>
                                {item.phone} (Score: {item.score})
                            </option>
                        ))}
                    </select>
                </label>

            
                <button
                    onClick={handleCheck}
                    disabled={loading}
                    style={{ marginTop: 12 }}
                >
                    {loading ? "Checking..." : "Check"}
                </button>

      
                {error && (
                    <p style={{ color: "red", marginTop: 8 }}>{error}</p>
                )}
            </div>

        </div> */}
        <div className="recommend-container">
            <div className="recommend-card-1">
                <h3 className="recommend-title">Fetch Recommendation Report</h3>

                {/* INFO NOTE */}
                <div className="recommend-info-box">
                    <p>
                        ⚠️ <strong>Testing Note (UAT):</strong><br />
                        Enter only those phone numbers for which the credit report has
                        already been fetched on the UAT server.
                    </p>
                    <p>
                        If you want to check recommendations for a new number, you must
                        first pull the report using:
                    </p>
                    <a>http://3.7.94.0:8002/login</a>
                </div>

                {/* PHONE INPUT */}
                <label className="recommend-label">
                    Phone Number
                    <input
                        type="tel"
                        placeholder="Enter phone number"
                        value={selectedPhone}
                        onChange={(e) => setSelectedPhone(e.target.value)}
                        className="recommend-input"
                    />
                </label>

                {/* DROPDOWN */}
                <label className="recommend-label">
                    Or Select Existing Number
                    <select
                        value={selectedPhone}
                        onChange={(e) => setSelectedPhone(e.target.value)}
                        className="recommend-select"
                    >
                        <option value="">-- Select --</option>
                        {list.map((item) => (
                            <option key={item.key} value={item.phone}>
                                {item.phone} (Score: {item.score})
                            </option>
                        ))}
                    </select>
                </label>

                {/* BUTTON */}
                <button
                    className="recommend-primary-btn"
                    onClick={handleCheck}
                    disabled={loading || !selectedPhone}
                >
                    {loading ? "Fetching Report..." : "Fetch Report"}
                </button>

                {/* ERROR */}
                {error && <p className="recommend-error">{error}</p>}
            </div>
        </div>
        <b style={{ display: reportNotFound ? "block" : "none" }}>Report not found</b>
        <div className="recommend-body">
            {RecommendationCategory("DEROGATORY_CLEANUP", data.DEROGATORY_CLEANUP)}
            {RecommendationCategory("PAYMENT_DISCIPLINE", data.PAYMENT_DISCIPLINE)}
            {RecommendationCategory("OVERDUE_NORMALIZATION", data.OVERDUE_NORMALIZATION)}
            {RecommendationCategory("ENQUIRY_CONTROL", data.ENQUIRY_CONTROL)}
            {RecommendationCategory("OPTIMIZE_CREDIT_MIX", data.OPTIMIZE_CREDIT_MIX)}
            {RecommendationCategory("ZERO_ACTIVE_CREDIT", data.ZERO_ACTIVE_CREDIT)}
            {/* {RecommendationCategory("SCORE_STABILITY", data.SCORE_STABILITY)}
            {RecommendationCategory("CREDIT_GROWTH", data.CREDIT_GROWTH)}
            {RecommendationCategory("CREDIT_PORTFOLIO_MATURITY", data.CREDIT_PORTFOLIO_MATURITY)}
            {RecommendationCategory("STRATEGIC_CREDIT_USAGE", data.STRATEGIC_CREDIT_USAGE)}
            {RecommendationCategory("FUTURE_READINESS", data.FUTURE_READINESS)}
            {RecommendationCategory("CREDIT_MONITORING", data.CREDIT_MONITORING)} */}
        </div>
    </>;
}

export default RecommendationScreen;
